import { useContext } from 'react';
import { PanelIdentifierContext } from '../splash/panels/PanelIdentifier';

/**
 * Permite acceder a la identidad del panel actual.
 */
export function usePanelIdentity() {
  const context = useContext(PanelIdentifierContext);

  if (!context)
    throw new Error('Trying to access an unexistent PanelIdentifierContext');

  return context;
}
